/*
 Цветовые схемы для графиков, сделаны на основе цветов из:
 https://vuetifyjs.com/en/styles/colors/#material-colors
*/

export const signalColorScheme: AxisColorScheme[] = [
  {
    mainColor: '#263238',
    comparedColors: ['#d62728', '#2ca02c', '#1f77b4', '#ff7f0e'],
  },
  {
    mainColor: '#9467bd',
    comparedColors: ['#8c564b', '#e377c2', '#7f7f7f'],
  },
  {
    mainColor: '#bcbd22',
    comparedColors: ['#17adae', '#f7b733', '#00b7f3'],
  },
  {
    mainColor: '#ff6f61',
    comparedColors: ['#6f2c91', '#ffb400', '#00a3e0'],
  },
  {
    mainColor: '#ab3c30',
    comparedColors: ['#00c48c', '#ff4081', '#a2b600'],
  },
];

export const spectrumColorScheme: AxisColorScheme[] = [
  {
    mainColor: '#263238',
    comparedColors: ['#37474F', '#455A64', '#546E7A', '#78909C'],
  },
  {
    mainColor: '#373CA6',
    comparedColors: ['#4E342E', '#6D4C41', '#8D6E63'],
  },
  {
    mainColor: '#FF6D00',
    comparedColors: ['#FF9100', '#FFAB40'],
  },
  {
    mainColor: '#827717',
    comparedColors: ['#9E9D24', '#C0CA33'],
  },
];

export const diagramsToCompareColorScheme: AxisColorScheme[] = [
  {
    mainColor: '#262626',
    comparedColors: [
      '#c42db5',
      '#00DC7D',
      '#FF756B',
      '#782FEF',
      '#FF2970',
      '#0351C1',
      '#F5E027',
      '#2398AB',
    ],
  },
];

export interface AxisColorScheme {
  mainColor: string;
  comparedColors: string[];
}

export const peaksColorScheme: string[] = [
  '#FF7043',
  '#F4511E',
  '#E64A19',
  '#D84315',
  '#BF360C',
  '#FF3D00',
  '#DD2C00',
];

export const cursorsColorScheme: string[] = [
  '#00FF00FF',
  '#0000FFFF',
  '#FF00FFFF',
  '#C0C0C0FF',
  '#C0C000FF',
  '#00FFFFFF',
  '#CCFF00FF',
  '#0033FFFF',
  '#CC3300FF',
  '#FF9999FF',
];

export interface OrAccelerometerWidgetColorScheme {
  normalColor: string;
  warningColor: string;
  dangerColor: string;
}

export const accelerometerColorScheme: OrAccelerometerWidgetColorScheme = {
  normalColor: '#94D455',
  warningColor: '#FEF54B',
  dangerColor: '#F34D2B',
};
